<template>
  <div class="w-header">
    <div class="w-content">
      <div class="w-content__item w-logo">
        <img :src="logo" />
        <span class="w-logo-text">{{$t('system')}}</span>
      </div>
      <div class="w-content__item w-tip">
        {{tip}}
      </div>
      <div class="w-content__item w-tool">
        <w-tool-item v-if="false" v-for="item in tools" :icon="item.icon" :name="item.name" :key="item.name" :remark="item.remark" :img="item.img"
          :link="item.link"></w-tool-item>
      </div>
    </div>
  </div>
</template>

<script>
  import WToolItem from './w-tool-item'
  export default {
    components: {
      WToolItem
    },
    props: {
      logo: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      tip: {
        type: String,
        default: ''
      },
      tools: {
        type: Array,
        default: () => ([])
      }
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
  $view-width: 1200px;
  .w-header {
    height: 60px;
    background-color: rgba(6, 16, 36, .2);
    font-size: 15px;
    color: #fff;
    z-index: 2;

    .w-logo {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      img {
        height: 40px;
      }
      &-text{
        color: white;
        margin-left: 24px;
        font-size: 18px;
      }
    }

    .w-content {
      max-width: $view-width;
      margin: 0 auto;
      height: inherit;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .w-content__item {
        +.w-content__item {
          margin-left: 12px;
        }
      }

      .w-tip {
        flex-grow: 1;
        text-align: right;
        font-size: 12px;
        transform: translateY(15px);
        padding-right: 5px;
      }

      .w-tool {
        margin-left: 0 !important;
        width: 340px;
        height: inherit;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .w-title {
        font-size: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/config/w-header.vue